module.exports = "/_next/static/images/caf69afadac2e649f82e178f1b332dcf-define-investment.png";